import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useInriStore } from '../stores/inriStore'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  left: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const inriStore = useInriStore()
const isOpen = computed(() => props.left ? inriStore.state.leftDrawerIsOpen : inriStore.state.rightDrawerIsOpen)

function toggle () {
  if (props.left) {
    inriStore.toggleLeftDrawer()
  } else {
    inriStore.toggleRightDrawer()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_drawer = _resolveComponent("q-drawer")!

  return (_openBlock(), _createBlock(_component_q_drawer, {
    "data-id": __props.left ? 'left-drawer' : 'right-drawer',
    "model-value": _unref(isOpen),
    side: __props.left ? 'left' : 'right',
    bordered: "",
    width: 340,
    class: "overflow-y-overlay",
    overlay: !__props.left,
    breakpoint: 600,
    "onUpdate:modelValue": toggle
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["data-id", "model-value", "side", "overlay"]))
}
}

})